import React from 'react';
import { Row, Col } from 'antd';

import { getName } from 'helpers/fieldsHelpers';

const LinkToEdit = ({ children, edit, className }) => <a className={className} onClick={edit}>{children}</a>;
const Span = ({ children, className }) => <span className={className}>{children}</span>;

export default function SotrMeetDescription ({ event: { comment, planedsotr, text }, edit }) {
    const EventNameWrap = edit ? LinkToEdit : Span;

    return (
        <div className="calendar-event-main-information">
            <EventNameWrap edit={edit} className="calendar-event-name">
                <span>{text}</span>
                <span> ({getName(planedsotr)})</span>
            </EventNameWrap>
            { comment &&
                <Row className="calendar-comment m-b-15">
                    <Col xs={20} sm={12} className="text-pre-space">
                        {comment}
                    </Col>
                </Row>
            }
        </div>
    )
}
